const Tamara = ({ ...props }) => {
    return (
        <svg
            width="34"
            height="24"
            viewBox="0 0 34 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
                fill="#FFD9B7"
            />
            <path
                d="M4 0.5H30C31.933 0.5 33.5 2.067 33.5 4V20C33.5 21.933 31.933 23.5 30 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z"
                stroke="#EAECF0"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.0468 15.8398C23.2559 15.8398 25.0468 14.0489 25.0468 11.8398C25.0468 9.63069 23.2559 7.83984 21.0468 7.83984C18.8377 7.83984 17.0468 9.63069 17.0468 11.8398C17.0468 14.0489 18.8377 15.8398 21.0468 15.8398ZM9.12848 9.18785C8.76668 9.56521 8.48335 10.0106 8.29492 10.4982L14.0721 15.2887C14.3563 15.1142 14.6173 14.9044 14.8487 14.6642L14.9615 14.5468C17.1504 12.2616 15.7126 9.78573 14.8405 8.95309C14.0825 8.22785 13.0676 7.83314 12.0188 7.85566C10.97 7.87819 9.97295 8.3161 9.24677 9.07322L9.12848 9.18785Z"
                fill="black"
            />
        </svg>
    )
}
export default Tamara
